import { render, staticRenderFns } from "./ChatMessageList.vue?vue&type=template&id=188365c1&scoped=true"
import script from "./ChatMessageList.vue?vue&type=script&lang=ts"
export * from "./ChatMessageList.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessageList.vue?vue&type=style&index=0&id=188365c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188365c1",
  null
  
)

export default component.exports